import { geoApi } from "../../api";
import { IpLocation } from "./geo.types";

export const geoFeatureApi = geoApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    getIpLocation: builder.query<IpLocation | null, void>({
      queryFn: async () => {
        try {
          const response = await fetch("https://ipwho.is/", {
            signal: AbortSignal.timeout(4000),
          });
          const data = await response.json();

          if (!response.ok || data?.success === false) {
            throw new Error(data?.message ?? "IP lookup failed");
          }

          return {
            data: {
              city: data.city ?? "",
              state: data.region ?? "",
              country: data.country ?? "",
            },
          };
        } catch {
          return { data: null };
        }
      },
    }),
  }),
});

export const { useGetIpLocationQuery } = geoFeatureApi;
